export { default as LoyaltyMarketingTileGroupWidget } from './loyalty-marketing-tile-widget';
